import type { UserLevel } from '@/types'

export interface MenuItemDef {
  key: string
  label: string
  path: string
  icon?: string
  requiredModule?: string
  requiredFunction?: string
  maxUserLevel: UserLevel
  children?: MenuItemDef[]
}

export const MENU_DEFINITIONS: MenuItemDef[] = [
  {
    key: 'games',
    label: '경기목록',
    path: '/games',
    icon: 'calendar',
    maxUserLevel: 9,
  },
  {
    key: 'estimate-settings',
    label: '배점 설정',
    path: '/estimate/settings',
    icon: 'audit',
    requiredModule: 'estimate',
    maxUserLevel: 4,
  },
  {
    key: 'estimate-results',
    label: '평가결과 조회',
    path: '/estimate/results',
    icon: 'audit',
    requiredModule: 'estimate',
    maxUserLevel: 5,
  },
  {
    key: 'agrees',
    label: '연봉협상 협의',
    path: '/agrees',
    icon: 'message',
    requiredModule: 'estimate',
    maxUserLevel: 5,
  },
  {
    key: 'stat-salary',
    label: 'Stat&연봉 비교',
    path: '/stat-salary',
    icon: 'lineChart',
    requiredModule: 'estimate',
    maxUserLevel: 5,
  },
  {
    key: 'batch',
    label: '배치 작업',
    path: '/batch',
    icon: 'setting',
    requiredModule: 'config',
    maxUserLevel: 0,
  },
  {
    key: 'data',
    label: '데이터 관리',
    path: '/data',
    icon: 'database',
    maxUserLevel: 0,
  },
]

export function filterMenu(
  menus: MenuItemDef[],
  userLevel: UserLevel,
  activeModules: string[],
  activeFunctions: string[],
): MenuItemDef[] {
  return menus
    .filter((menu) => {
      const levelOk = userLevel <= menu.maxUserLevel
      const moduleOk = !menu.requiredModule || activeModules.includes(menu.requiredModule)
      const funcOk = !menu.requiredFunction || activeFunctions.includes(menu.requiredFunction)
      return levelOk && moduleOk && funcOk
    })
    .map((menu) => ({
      ...menu,
      children: menu.children
        ? filterMenu(menu.children, userLevel, activeModules, activeFunctions)
        : undefined,
    }))
}
